import httpClient from './httpClient';

export default {
  createOffer: leadId => httpClient.post(`/api/lead/${leadId}/offers`),
  sendHeartBeat: leadId => httpClient.post(`/api/lead/heartbeat/${leadId}`),
  sendSocialSecurityNumber: (leadId, ssn) =>
    httpClient.post(`/api/lead/${leadId}/secureStore/SSN?encrypt=1`, {
      SSN: ssn,
    }),
  createConsumerId: leadBody => httpClient.post('/api/v3/consumers', leadBody),
  createLead: (consumerId, leadBody) => httpClient.post(`/api/v3/consumers/${consumerId}/leads`, leadBody),
  getConsumerBasicInfo: consumerId => httpClient.get(`/api/v3/consumers/${consumerId}/basic-info`),
  sendConsumerMobileOtp: consumerId => httpClient.post(`/api/v3/consumers/${consumerId}/mobile-otp`),
  verifyConsumerMobileOtp: (consumerId, otp, requestedInfo) =>
    httpClient.put(`/api/v3/consumers/${consumerId}/mobile-otp`, {
      token: otp,
      requestedInfo,
    }),
  updateLead: (updateLeadBody, leadId, options) =>
    httpClient.post(`/api/lead/update/${leadId}`, updateLeadBody, options),
  updateLeadMetadata: (consumerId, leadId, metaData) =>
    httpClient.put(`api/v3/consumers/${consumerId}/leads/${leadId}/metadata`, metaData),
  sendFinanceApplication: (consumerId, leadId, financeBody) =>
    httpClient.post(`api/v3/consumers/${consumerId}/leads/${leadId}/finance-applications`, financeBody),
  completeLead: leadId => httpClient.post(`/api/lead/complete/${leadId}`),
};
